import { TOOLBAR_SELECT_CLASS } from './ListToolbar';
import { Select } from './Select';

interface PageSizeSelectProps {
  value: number;
  options: readonly number[];
  onChange: (size: number) => void;
}

/** Figma Input "보기: 25개" — 한 페이지에 보여 줄 개수 */
export function PageSizeSelect({
  value,
  options,
  onChange,
}: PageSizeSelectProps) {
  return (
    <Select
      label="보기"
      allLabel={null}
      value={String(value)}
      options={options.map((size) => ({
        value: String(size),
        label: `${size}개`,
      }))}
      onChange={(next) => onChange(Number(next))}
      className={TOOLBAR_SELECT_CLASS}
    />
  );
}
